


















































































  import Vue from 'vue';
import Component from 'vue-class-component';
  
  @Component
  export default class PlaygroundTextareaWrapper extends Vue {
    public label: string = 'show';
    public state: string = 'error';
  }
